import Quill from 'quill';

import * as modules from '.';

Object.keys(modules).forEach((moduleName) => {
  const module = modules[moduleName];

  Quill.register(
    {
      [`modules/${module.moduleName}`]: module,
    },
    true,
  );
});
